import React from "react";
import { ShippingCartIconProps } from "./Packable.types";
import { logDebug, mergeProperties } from "packable-components";
import { Theme, useTheme } from "@mui/material/styles";
import { Badge, Grid } from "@mui/material";
import { DomainAdd, ShoppingCartCheckout } from "@mui/icons-material";

const useStyles = (theme: Theme) => ({
  PackableShippingCartIconCountBadge: {
    muiColor: "secondary",
  },
});

export const StorageShippingCartIcon: React.FC<ShippingCartIconProps> = (
  props
): React.JSX.Element => {
  const { itemCount, styles } = props;

  logDebug("StorageShippingCartIcon PROPS");
  logDebug(props);

  const theme = useTheme();
  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("StorageShippingCartIcon Effective Styles");
  logDebug(props);

  return (
    <Grid>
      <Grid
        sx={{
          display: "fixed",
          position: "absolute",
          top: "0px",
          left: "14px",
        }}
      >
        <DomainAdd sx={{ width: "16px" }} />
      </Grid>
      <Grid>
        <Grid sx={{ display: "flex" }}>
          <Badge
            className="PackableShippingCartIconCountBadge"
            sx={effectiveStyles.PackableShippingCartIconCountBadge}
            badgeContent={itemCount}
            color={effectiveStyles.PackableShippingCartIconCountBadge.muiColor}
          >
            <ShoppingCartCheckout />
          </Badge>
        </Grid>
      </Grid>
    </Grid>
  );
};
